import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Button,
  Avatar,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemText,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import Logo from "../../Assets/Images/logo.png";
import { Link } from "react-router-dom";
import { theme } from "../../Assets/Theme/theme";
import { useLocation, useNavigate } from "react-router-dom";
import { CurrencyContext } from "../../Services/CurrencyContext";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { currencyOptions } from "../../Services/dymmyData";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";

const SearchIcon = ({ width = "24", height = "24", color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={width}
    height={height}
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

function Navbar({ searchQuery, setSearchQuery }) {
  const themes = useTheme();
  const isSmallScreen = useMediaQuery("(max-width: 1120px)");
  const location = useLocation();
  const navigate = useNavigate();
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const { currency, setCurrency } = useContext(CurrencyContext);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  const handleCurrencyChange = (event) => {
    if (currency) {
      setCurrency(event.target.value);
    } else {
      setAPICurrency(event.target.value);
    }
  };

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [apiCurrency, setAPICurrency] = useState('')

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setShowSearch(true);
    } else {
      setShowSearch(false);
    }
  };

  useEffect(() => {
    let previousCurrency = null;

    const fetchCurrency = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/user/setting`);
        const newCurrency = response?.data?.data?.currency;

        if (newCurrency && newCurrency !== previousCurrency) {
          setAPICurrency(newCurrency);
          previousCurrency = newCurrency;
        }
      } catch (error) {
        console.error("Error fetching currency setting:", error?.response);
      }
    };

    fetchCurrency();

    const intervalId = setInterval(fetchCurrency, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    if (loginData?.token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("loginData");
    setIsLoggedIn(false);
    navigate("/login");
    setOpenLogoutDialog(false);
  };

  const handleLogoutClick = () => {
    setOpenLogoutDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenLogoutDialog(false);
  };


  return (
    <AppBar position="static" color="inherit" elevation={0}>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          background: "#fff",
          paddingX: 2,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          boxShadow: showSearch && "0px 4px 6px rgba(255, 121, 0, 0.5)"
        }}

      >
        <Box display="flex" alignItems="center">
          <Link to="/">
            <img
              src={Logo}
              alt="Logo"
              style={{
                width: isSmallScreen ? 60 : 80,
                height: isSmallScreen ? 60 : 80,
                marginRight: 10,
                cursor: "pointer",
                marginTop: "5px",
              }}
            />
          </Link>
        </Box>

        {!isSmallScreen && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            {/* <Button
              sx={{
                color:
                  location.pathname === "/" ? theme.colors.orange : "#121212",
                fontWeight: "500",
                fontSize: "18px",
                textTransform: "none",
                "&:hover": {
                  color: theme.colors.orange,
                  background: "transparent",
                },
              }}
              onClick={() => navigate("/")}
            >
              Home
            </Button> */}
            {/* <Button
              onClick={() => navigate("/experience")}
              sx={{
                color:
                  location.pathname === "/experience" ||
                    location.pathname === "/experience-detail" ||
                    location.pathname === "/my-cart"
                    ? theme.colors.orange
                    : "#121212",
                textTransform: "none",
                fontWeight: "500",
                fontSize: "18px",
                "&:hover": {
                  color: theme.colors.orange,
                  background: "transparent",
                },
              }}
            >
              Experience
            </Button> */}
            {loginData?.token && <Button
              onClick={() => navigate("/my-bookings")}
              sx={{
                color:
                  location.pathname === "/my-bookings"
                    ? theme.colors.orange
                    : "#121212",
                textTransform: "none",
                fontWeight: "500",
                fontSize: "18px",
                "&:hover": {
                  color: theme.colors.orange,
                  background: "transparent",
                },
              }}
            >
              My Bookings
            </Button>}
            {/* <Button
              onClick={() => navigate("/contact")}
              sx={{
                color:
                  location.pathname === "/contact"
                    ? theme.colors.orange
                    : theme.colors.text,
                textTransform: "none",
                fontWeight: "500",
                fontSize: "18px",
                "&:hover": {
                  color: theme.colors.orange,
                  background: "transparent",
                },
              }}
            >
              Contact Us
            </Button> */}
          </Box>
        )}

        {showSearch && !isSmallScreen && location.pathname !== "/experience-detail" && location.pathname !== "/contact" && location.pathname !== "/experience" && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              width: 600,
              padding: "20px",
              margin: "auto",
            }}
          >
            <TextField
              variant="outlined"
              fullWidth
              label="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "50px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "30px",
                  "& fieldset": {
                    borderColor: "#FFFFFF",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  },
                  // "& input": {
                  //   padding: "12px 16px",
                  // },
                },
              }}
            />

            <Button
              variant=""
              sx={{
                textTransform: "none",
                padding: "10px",
                margin: "-10px",

                "&:hover": {
                  color: "black",
                  padding: "0px",
                },
              }}
            >
              <SearchIcon width="30" height="30" color="orange" />
            </Button>
          </Box>
        )}

        <Box display="flex" alignItems="center" gap={2}>
          <IconButton onClick={() => navigate("/my-cart")}>
            <ShoppingBagOutlinedIcon
              sx={{
                width: 30,
                height: 30,
                color:
                  location.pathname === "/my-cart" ||
                    location.pathname === "/fillForm" ||
                    location.pathname === "/checkout"
                    ? theme.colors.orange
                    : theme.colors.text,
                textTransform: "none",
                "&:hover": {
                  color: theme.colors.orangeLight,
                  background: "transparent",
                },
              }}
            />
          </IconButton>
          <Avatar
            sx={{
              bgcolor: theme.colors.orange, width: "30px", height: "30px", "&:hover": {
                cursor: "pointer",
              },
            }}
            onClick={() => navigate("/profile")}
          >
            {isLoggedIn && loginData?.user?.user
              ? loginData.user.user.charAt(0).toUpperCase()
              : "G"}
          </Avatar>

          {isSmallScreen ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fff",
                borderRadius: "50px",
                //  padding: "5px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                border: "1px solid #ddd",
                width: "100%",
                maxWidth: "400px",
                height: "50px",
              }}
            >
              <TextField
                variant="outlined"
                label="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputLabelProps={{
                  sx: {
                    color: "#888",
                    backgroundColor: "white",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    "&.Mui-focused": {
                      color: "#888",
                      backgroundColor: "white",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      marginTop: "5px",
                    },
                  },
                }}
                InputProps={{
                  sx: {
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                    paddingRight: 0,
                  },
                }}
              />
              <Button
                variant="text"
                sx={{
                  minWidth: "auto",
                  padding: "10px",
                  "&:hover": {
                    color: "black",
                  },
                }}
              >
                <SearchIcon width="15" height="15" color="orange" />
              </Button>
            </Box>
          ) : location.pathname !== "/my-bookings" && (
            <FormControl variant="outlined" sx={{ minWidth: 100 }}>
              <InputLabel>Currency</InputLabel>

              <Select
                value={currency}
                onChange={handleCurrencyChange}
                label="Currency"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  height: "35px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#ddd",
                    },
                  },
                }}
              >
                {currencyOptions.map((option, index) => (
                  <MenuItem key={option.value} value={option.value}>
                    <img
                      src={option.image}
                      alt={option.label}
                      style={{
                        width: index === currencyOptions.length - 1 ? 20 : 15,
                        height: index === currencyOptions.length - 1 ? 10 : 16,
                        marginRight: 8,
                        verticalAlign: 'middle'
                      }}
                    />
                    {option.label}
                  </MenuItem>
                ))}

              </Select>

            </FormControl>
          )}

          {isSmallScreen ? (
            <IconButton edge="end" color="inherit" onClick={handleDrawerToggle}>
              <MenuIcon />
            </IconButton>
          ) : isLoggedIn ? (

            <IconButton
              onClick={handleLogoutClick}
              sx={{
                color: themes.colors.orange,
                cursor: "pointer",
                "&:hover": {
                  cursor: 'pointer'
                },
              }}
            >
              <PowerSettingsNewIcon sx={{ fontSize: "32px" }} />
            </IconButton>
          ) : (
            <Button
              onClick={() => navigate("/login")}
              sx={{
                color: theme.colors.orange,
                textTransform: "none",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              Login / Signup
            </Button>
          )}

        </Box>
      </Toolbar>

      <Dialog
        open={openLogoutDialog}
        onClose={handleCloseDialog}
        aria-labelledby="logout-dialog-title"
      >
        <DialogTitle id="logout-dialog-title">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you really want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="black" sx={{
            backgroundColor: theme.colors.lightGrey,
            borderRadius: '5px',
            color: 'grey',
            '&:hover': {
              backgroundColor: '#A9A9A9',
              color: 'white'
            },
          }}>
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            autoFocus
            sx={{
              backgroundColor: theme.colors.orange,
              borderRadius: '5px',
              color: 'white',
              '&:hover': {
                backgroundColor: 'darkorange',
              },
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>


      {/* Avatar Dropdown Menu */}
      {/* {loginData?.token && <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: theme.colors.orange, 
            marginTop: "5px",
            borderRadius: "8px", 
          },
        }}
      >
       <Button
        style={{
          fontWeight: "bold",
          color: "white",
          backgroundColor: theme.colors.orange,
          margin: "5px",
          borderRadius: "3px",
          textTransform: "none",
          fontSize: "18px",
          justifyContent: 'center',
          width: "100px",
          height: "20px"
        }}
        onClick={() => navigate("/profile")}
      >
        Profile
      </Button>
      </Menu>
      } */}

      <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
        <Box sx={{ width: 250, padding: 2 }} role="presentation">
          {/* Navigation Options */}
          <List>
            {["Home", "Experience", "My Bookings", "Contact Us", "Profile"].map(
              (text, index) => (
                <ListItem
                  key={index}
                  component="button"
                  onClick={() => {
                    if (text === "Home") {
                      navigate("/");
                    } else {
                      navigate(`/${text.toLowerCase().replace(" ", "-")}`);
                    }
                  }}
                  sx={{ backgroundColor: "transparent", border: "none" }}
                >
                  <ListItemText
                    sx={{
                      color:
                        location.pathname ===
                          `/${text.toLowerCase().replace(" ", "-")}`
                          ? theme.colors.orange
                          : theme.colors.text,
                    }}
                    primary={text}
                  />
                </ListItem>
              )
            )}

            {location.pathname !== "/my-bookings" && <ListItem>
              <FormControl variant="outlined" sx={{ minWidth: 200 }}>
                <InputLabel>Currency</InputLabel>
                <Select
                  value={currency || apiCurrency}
                  onChange={handleCurrencyChange}
                  label="Currency"
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "4px",
                    height: "35px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#ddd",
                      },
                    },
                  }}
                >
                  <MenuItem value="$">$ USD</MenuItem>
                  <MenuItem value="€">€ EUR</MenuItem>
                  <MenuItem value="£">£ GBP</MenuItem>
                  <MenuItem value="₹">₹ INR</MenuItem>
                  <MenuItem value="A$">A$ AUD</MenuItem>
                  <MenuItem value="د.إ">د.إ AED</MenuItem>
                  <MenuItem value="﷼">﷼ SAR</MenuItem>

                </Select>
              </FormControl>
            </ListItem>}

            {/* Logout Option */}
            {isLoggedIn ? (
              <ListItem
                component="button"
                onClick={handleLogout}
                sx={{ backgroundColor: "transparent", border: "none" }}
              >
                <ListItemText
                  sx={{
                    color:
                      location.pathname === "/logout"
                        ? theme.colors.orange
                        : theme.colors.text,
                  }}
                  primary="Logout"
                />
              </ListItem>
            ) : (
              <ListItem
                component="button"
                onClick={() => navigate("/login")}
                sx={{ backgroundColor: "transparent", border: "none" }}
              >
                <ListItemText
                  sx={{
                    color:
                      location.pathname === "/login"
                        ? theme.colors.orange
                        : theme.colors.text,
                  }}
                  primary="Login / SignUp"
                />
              </ListItem>
            )}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}

export default Navbar;

